export default {
  ru: "RU",
  kk: "KZ",
  hello: "Salem",
  attention: "Назар аударыңыз",
  cancel: "Болдырмау",
  update: "Жаңарту",
  close: "Жабу",
  "no-data": "Деректер жоқ",
  back: "Кері қарай",
  summary: "Барлығы",
  expand: "Кеңейту",
  questionnaire: {
    notice:
      "Құрметті тұтынушы! Көрсетілетін қызметтердің сапасын жақсарту мақсатында <u>Сауалнамамыздың</u> сұрақтарына жауап беруіңізді сұраймыз!",
    title:
      "Тұтынушы - заңды тұлғалардың қанағаттанушылығын бағалау сауалнамасы",
    title1: "Құрметті тұтынушы!",
    title2:
      "Қызмет көрсету сапасын жақсарту мақсатында «АлматыЭнергоСбыт» ЖШС-нің көрсетілетін қызметтеріне қолма-қол ақшасыз төлеу мүмкіндігін ұсыну мәніне тұтынушы заңды тұлғалардың сауалнамасы жүргізілуде.",
    title21:
      "Көрсетілген қызмет пен сатылатын өнімнің сапасын арттыру мақсатында «Алатау Жарық Компаниясы» АҚ филиалы - «Энергосбыт» өзінің қызметі туралы Сіздің пікіріңізді білуге ұмтылады. Сізден төмендегі сұрақтарға жауап беруіңізді сұраймыз, «АлматыЭнергоСбыт» ЖШС мамандары алдағы уақытта Сіздің пікіріңізді міндетті түрде ескереді.",
    title3: "Қатысуыңызды сұраймыз!",
    title4: "Сіздің кәсіпорыныңыздың:",
    title5: "Көрсетілген көмегіңіз үшін алғыс білдіреміз!",
    "question-number": "{count}-дан №{num} сұрақ",
    send: "Сауалнаманы жіберу",
    next: "Келесі",
    fill: "Тауарлар/қызметтер тізбесін көрсетіңіз",
    select:
      "«Алатау Жарық Компаниясы» АҚ филиалы - «Энергосбыт» жұмысына қанағаттанушылық деңгейін 5-баллдық шәкіл бойынша бағалаңыз (қажеттісін дөңгелектендіру керек): 1 - жаман, 2 - қанағаттанарлықсыз, 3 - қанағаттанарлық, 4 - жақсы, 5 - өте жақсы.",
  },
  ui: {
    print: "Басып шығару",
    labels: {
      yes: "Иә",
      no: "Жоқ",
      close: "Жабу",
    },
    wait: "Күтуіңізді сұраймыз...",
    document_loading:
      "Сіздің құжатыңыз жүктелуде және ол осы терезеде ашылатын болады. Күтуіңізді сұраймыз...",
    list_all: "Барлығы",
    no_data_for_period: "Таңдалған кезеңде деректер жоқ",
    "date-picker": {
      label: "Кезеңді таңдаңыз",
      from: "бастап",
      to: "дейін",
    },
    errors: {
      timeout: "Пайдаланушылар саны артты.<br/>Кейінірек кіруіңізді сұраймыз",
    },
  },
  messageAyth:
    "Құрметті пайдаланушы! Енді Сізде расталған электрондық мекенжай бойынша Жеке кабинетке кіру мүмкіндігі бар. Ол үшін Жеке кабинеттің бейінінде құпиясөзді орнатыңыз. Құрметпен, «АлмаыЭнергоСбыт» ЖШС.",
  "update-checker": {
    message:
      'Жеке кабинеттің жаңа нұсқасы қол жетімді.<br /><br />Жаңарту керек пе?<br /><br /> Бетті қайта жүктеу үшін "Жаңарту" түймесін басыңыз.Барлық енгізілген деректер жоғалады.',
  },
  maintenance: {
    message:
      '<center><b>Назар аударыңыз!</b> <br /><br /> <span style="font-weight: 400"> Техникалық жұмыстар жүргізілуде. <br /><br /> Келтірілген қолайсыздықтар үшін кешірім сұраймыз.</span> </center>',

    banner: {
      title: "Техникалық жұмыстар жүргізілуде",
      description:
        "Қызметтердің уақытша қолжетімсіз болуы мүмкін. Түсінгеніңіз үшін рахмет.",
    },
  },
  "app-header": {
    feedback: "Кері байланыс",
    "contact-center": "Тәулік бойы жұмыс істейтін Контакт орталығы 356-99-99",
    departments: "АлматыЭнергоСбыт аудандық бөлімшелері (АЭЖБ)",
  },
  "app-navigation": {
    contract: "Шарт",
    "contract-placeholder": "Нөмірді таңдаңыз",
    bin: "БСН",
    organization: "Ұйым",
    "home-tooltip": "Шарттар тізімі",
    "profile-tooltip": "Бейін",
    "exit-tooltip": "Шығу",
    "pay-tooltip": "Төлеу",
    "appeal-tooltip":
      "Менің өтініштерім. Ұсыныстар мен өтініштер жіберуге және «Алатау Жарық Компаниясы» АҚ филиалы - «Энергосбыт» - тан жауаптар алуға арналған кері байланыс нысаны",
    contracts:
      "Шарт туралы жалпы ақпарат: жасалған күні, көрсеткіштерді ұсыну күні",
    abonent:
      "Мұнда сіздің деректемелеріңіз көрсетілген: ҚҚС бойынша есепке қою туралы куәлік, қызметкерлер туралы ақпарат",
    points:
      "Орнатылған есепке алу құралдары, пломбалар және ток трансформаторлары туралы ақпарат, тарифтер, ТҚС",
    calcs:
      "Қызметтер мен кезеңдер бойынша есептеулер мен төлемдер туралы ақпаратты қарау",
    actions:
      "Көрсеткіштерді беру, Салыстыру актісін және Орындалған жұмыстар актісін алу және жіберу",
    notices: "Қарыз туралы хабарламаларды қарау",
    reports:
      "Құжаттарды қарау: өзара есеп айырысуларды салыстыру актілері, орындалған жұмыстардың актілері, төлем шоттары, 2-қосымша",
    invoices: "Шот-фактураларды қарау",
  },
  "app-menu": {
    "debt-button": "Шарт бойынша қарыз",
    contract: "Шарт",
    abonent: "Тұтынушы",
    "accounting-points": "Есепке алу нүктелері",
    payments: "Есептеу мен төлем",
    "report-forms": "Есептік  нысандар",
    actions: "Шарт бойынша іс-әрекеттер",
    "debt-notifications": "Қарыз туралы хабарламалар",
    invoices: "Шот-фактуралар",
  },
  "app-footer": {
    text: "АЖК» АҚ филиалы-Энергосбыт. «АЛСЕКО» АҚ әзірлеген",
  },
  "auth-view": {
    title: "Заңды тұлғалар үшін жеке кабинет",
    setted: "Құпия сөзді орнату сілтемесі Сіздің поштаңызға жіберілді.",
    forgot: "Құпиясөзді ұмыттыңыз ба?",
    restore: "Жеке кабинеттің құпиясөзін қалпына келтіру",
    back: "<< Кіруге оралу",
    confirm: "Растау",
    message1:
      "Құпиясөзді қалпына келтіру туралы сұрау расталғаннан кейін сіз құпиясөзді қалпына келтіру бойынша нұсқаулықтары бар хатты аласыз.",
    message2:
      "Құпиясөзді қалпына келтіру Жеке кабинетте электрондық мекенжай расталған жағдайда ғана мүмкін болады.",
    "send-restore-mail":
      "Сіздің электрондық мекенжайыңызға құпиясөзді қалпына келтіру бойынша нұсқаулық жіберілді. Поштаңызды тексеріңіз.",
    message3:
      "Пайдаланушы тіркелмеген немесе БСН қате терілген, деректерді тексеріңіз",
    notice:
      "Электрондық мекенжай бойынша Жеке кабинетке кіру Жеке кабинетте электрондық мекенжай расталған жағдайда ғана мүмкін болады.",
    updated: "Құпиясөз өзгертілді. Жаңа құпиясөзді ",
    updated2: " үшін қолдана аласыз.",
    "new-passw": "Жаңа құпиясөз",
    "retry-pass": "Құпиясөзді растау",
    enter: "Кіру",
    form: {
      title: "ЭСҚ-сыз кiру",
      "enter-bin": "БСН енгізіңіз",
      "enter-iin": "ЖСН енгізіңіз",
      "credentials-title": "Өкілеттікті таңдаңыз",
    },
    "form-eds": {
      title: "ЭСҚ арқылы кіру",
    },
    "form-email": {
      title: "Email арқылы кіру",
    },
    manuals: {
      "video-inctruction": {
        title: "Жеке кабинет жұмысының бейне нұсқаулығын карау",
        href: "https://esalmaty.kz/kz/i3399",
      },
      "get-eds": {
        title: "Заңды тұлғалар үшін ЭЦҚ алу",
        href: "https://egov.kz/cms/kk/services/pass_onlineecp",
      },
      "pay-instruction": {
        title: "Онлайн төлем бойынша нұсқаулық",
      },
      instruction: {
        title: "Нұсқаулық",
      },
      "sign-act-instruction": {
        title: "Актілерге қол қою және қабылдамау бойынша нұсқаулық",
      },
    },
  },
  credentials: {
    individual: "Жеке тұлға",
    legal: "Заңды тұлға",
    "first-leader": "Заңды тұлғаның қол қоюға құқылы бірінші басшысы",
    signer: "Қол қою құқығы бар тұлға",
    "financial-signer": "Қаржылық құжаттарға қол қою құқығы бар тұлға",
    hr:
      "Заңды тұлға қызметкерлерінен берілген тіркеу куәліктерін шығаруға арналған өтінімдерді растау құқығы берілген кадр бөлімінің қызметкері",
    employee: "Ұйымның қызметкері",
  },
  "form-validator": {
    decimal3: "KK Числовое поле, 10 знаков с точностью до тысячных",
    required: "Міндетті түрде толтырылуы қажет жол",
    "string-max": "Жолдың максималды ұзындығы {max} таңба",
    "string-min": "Жолдың минималды ұзындығы {min} таңба",
    bin: "БСН форматы қате",
    biniin: "Қате БСН/ЖСН",
    iin: "ЖСН форматы қате",
    email: "Қате email енгізілген",
    pass:
      "Енгізілген құпиясөз қауіпсіздік талаптарына сәйкес келмейді. Жаңа құпиясөзде болуы керек: Ең аз дегенде 8; ең көп дегенде 12; таңба 1 сан; жоғарғы регистрдегі латын әліпбиінің 1 әрпі; төменгі регистрдегі латын әліпбиінің 1 әрпі; 1 арнайы таңба (@#$%&); Енгізу үшін тек латын алфавитінің әріптерін қолданыңыз;",
    password: "Құпия сөз",
    passwordRepeated: "Құпия сөзді қайталаңыз",
    pass_create:
      "Пайдаланушының кабинетіне кіру үшін жаңа құпиясөзді енгізіңіз.",
    pass_rep_incorr: "Енгізілген құпия сөздер сәйкес келмейді.",
    link_expired:
      'Осы сілтеменің қолданылу мерзімі аяқталды. Жаңа сілтеме алу үшін "Құпия сөзді қалпына келтіру" батырмасын  басыңыз',
    link_expired2: "Сілтеме ескірген немесе бұрын қолданылған",
    pass_updated:
      "KK Пароль успешно обновлен. Вы будете перенаправлены на страницу входа",
    enter_pass: "Құпия сөзді енгізіңіз",
  },
  storages: {
    computer: "Сіздің компьютеріңіз",
    "kaz-token": "Казтокен",
    "id-card": "Жеке куәлік",
    "e-token": "EToken Java 72k",
    "ak-ja-carta": "AK JaCarta",
  },
  eds: {
    sign: "Қол қою",
    reject: "Қабылдамау",
    "sign-with-eds": "ЭЦҚ арқылы қол қою",
    error:
      "Электрондық цифрлық қолтаңба кілттерімен жұмыс істеу үшін NCALayer бағдарламасын орнатыңыз немесе іске қосыңыз",
  },
  profile: {
    title: "Бейін",
    organization: {
      title: "Ұйым бойынша мәліметтер",
      "bin-iin": "БСН/ЖСН",
      name: "Атауы",
      set_password: "Құпиясөзді орнату",
      update_password: "Құпиясөзді өзгерту",
      email: {
        title: "Email",
        placeholder: "Email-ді енгізіңіз",
        edit: "Email-ді өзгерту",
        save: "Email-ді сақтау",
        cancel: "Email-дің өзгеруін болдырмау",
        "not-verified": "Сіздің электрондық мекен-жайыңыз расталған жоқ",
        "card-no-email":
          "Электрондық мекен-жай енгізілмеген. Жеке кабинеттің барлық мүмкіндіктерін пайдалану үшін Сіздің электрондық мекен-жайыңызды енгізіп, растаңыз",
        "card-title": "Email-ды растау",
        "card-not-verified":
          "Сіздің электрондық мекен-жайыңыз{email} расталған жоқ. <br />Жеке кабинеттің барлық мүмкіндіктерін пайдалану үшін электрондық мекен-жайды растау қажет.",
        "card-link": "Растау сілтемесін қайта жіберу",
        "card-text-send":
          "Сіздің {email} электрондық мекен-жайыңызға email-ды растау сілтемесі бар хат жіберілді",
        "card-text-confirm": "Сіздің электрондық мекен-жайыңыз сәтті расталды",
      },
    },
    users_management: {
      title: "Пайдаланушыларды басқару",
      first_name: "Аты",
      last_name: "Тегі",
      patronymic: "Әкесінің аты",
      iin: "ЖСН",
      roles: "Рөлдер",
      email: "Email",
      contracts: "Шарттар",
      status: {
        label: "Мәртебесі",
        active: "Белсенді",
        blocked: "Бұғатталған",
      },
      status_filter: {
        all: "Барлық",
        active: "Белсенді",
        blocked: "Бұғатталған",
      },
      email_not_verified: "Email расталған жоқ",
      email_verification:
        "{email} электрондық мекенжайы расталмаған. Хабарламаларды алу үшін электрондық мекенжайды растау қажет",
      email_verification_sent:
        "{email} электрондық мекен-жайыңызға email-ды растау сілтемесі бар хат жіберілді",
      email_unavailable: "Электрондық мекенжай базада бар. Басқасын көріңіз.",
      contracts_header: "Шарттар үшін жауапты",
      add_user: "Жаңа пайдаланушыны қосу",
      edit_user: "Пайдаланушыны редакциялау",
      placeholder: {
        first_name: "Атыңызды енгізіңіз",
        last_name: "Тегіңізді енгізіңіз",
        patronymic: "Әкеңіздің атын енгізіңіз",
        iin: "ЖСН енгізіңіз",
        email: "Email-ді енгізіңіз",
        role: "Рөлді таңдаңыз",
        contract: "Шартты таңдаңыз",
      },
      button: {
        add_user: "Пайдаланушыны қосу",
        edit: "Редакциялау",
        add: "Қосу",
        cancel: "Болдырмау",
        save: "Сақтау",
      },
      errors: {
        user_add: "Жаңа пайдаланушыны құру кезіндегі қате",
        user_edit: "Пайдаланушының деректерін сақтау кезіндегі қате",
      },
      confirmation: {
        block:
          "Сіз {user} ({email}) пайдаланушысын бұғаттауды растайсыз ба?<br><b>Бағдарламадағы пайдаланушының жұмысы аяқталады</b>",
        unblock: "{user} пайдаланушының бұғаттан шығарылуын растайсыз ба?",
      },
    },
  },
  contracts: {
    number: "Шарт",
    date: "Жасалған күні",
    region: "Аймақ",
    list: "Шарттар тізімі",
    empty: "Қолданыстағы шарттар жоқ",
  },
  contractInfo: {
    contract_number: "Шарт",
    contract_open_date: "Жасалған күні",
    roes: "АЭЖБ",
    contract_phone: "Телефондар",
    suppl_org_branch_address: "Мекенжайы",
    date_contract_pay_day: "Шарт бойынша төлем күні",
    date_check: "Көрсеткіштерді ұсыну күні",
    ingener_calc: "Инженер-есептеуші",
    info: "Ақпарат",
    saldo: "Ағымдағы сальдо, тг",
    saldo_peni: "Өсімақы сальдосы, тг",
    saldo_duty: "Мемлекеттік баж сальдосы, тг",
    assigned_power: "Белгіленген қуат, кВт",
    rate_nds: "ҚҚС, %",
    contract_consumption_category: "Тұтынушы санаты",
    contract_consumption_category_group: "Тұтынушы тобы",
    week_ends: "Аптадағы демалыс күндерінің саны",
    work_hours: "Тәуліктегі жұмыс сағаттарының саны",
    "1e":
      "1Э қосымшасы. {year} жылға арналған электр энергиясы мен қуатын босату көлемі, кВт∙сағ",
    status: {
      added:
        "Назар аударыңыз! Сіздің электрмен жабдықтау объектілеріңізде {contract_id} шарты бойынша электр энергиясын жеткізу тоқтатылады.",
      in_process:
        "Назар аударыңыз! Сіздің электрмен жабдықтау объектілеріңізде {contract_id} шарты бойынша электр энергиясын жеткізу {date} тоқтатылады.",
      terminated:
        "Назар аударыңыз! Сіздің электрмен жабдықтау объектілеріңізде {contract_id} шарты бойынша электр энергиясын жеткізу {date} тоқтатылды.",
      info:
        "<br /><br />Мерзімі өткен дебиторлық қарыз үшін өшірілген электрмен жабдықтау объектілерін қайта қосу үшін міндетті түрде {sumPPE} теңге мөлшерінде төлем алынады.",
    },
  },
  abonentInfo: {
    consumer: "Тұтынушы",
    req: "Деректемелер",
    contract_bin: "БСН/ЖСН",
    contract_bank_name: "Банктің атауы",
    contract_bank_number: "Есеп айырысу/корреспонденттік шот",
    is_resident: "Резидент",
    yes: "иә",
    no: "жоқ",
    contract_kbe: "Экономика секторы",
    contract_knp: "Төлемді тағайындау коды",
    contractor_country_name: "Резидент елінің коды",
    district_name: "Әкімшілік ауданы",
    contractor_real_address: "Орналасқан жерініӊ мекенжайы",
    receiver_name: "Жүк алушы",
    contract_address: "Заңды мекенжайы",
    contract_post_index: "Пошта индексі",
    nds: "ҚҚС бойынша есепке қою туралы куәлік",
    contract_nds_date: "Күні",
    contractor_tax_branch_name: "Салық органы",
    nds_series: "Сериясы",
    nds_number: "Нөмірі",
    employes: "Қызметкерлер және байланыс ақпараты",
    phone: "Телефон",
    fax: "Факс",
    email: "Email",
  },
  accountingPoints: {
    more_details: "Толығырақ",
    points: "Есепке алу нүктелері",
    account_point_number: "Нөмірі",
    account_point_name: "Атауы",
    status: "Мәртебесі",
    meter_next_verify_date: "Есепке алу құралын тексеру күні",
    tarif_value: "Тариф, тг (ҚҚС-сыз)",
    net_node_name: "ТҚС нөмірі (ТП, секциялар)",
    account_point_full_address_name: "Мекенжайы",
    connected: "Қосылған",
    disconnected: "Өшірілген",
    all: "Барлығы",
    connecting: "Қосылған",
    disconnecting: "Өшірілген",
  },
  pointMeter: {
    meter: "Есепке алу құралы",
    meter_number: "Нөмірі",
    meter_type_name: "Түрі",
    prec_phase_number: "Мәнділігі/Фазалылығы",
    meter_install_date: "Орнату күні",
    meter_next_verify_date: "Тексеру күні",
    sum_consumption: "Соңғы шығыны",
  },
  pointSeal: {
    seals: "Пломбалар",
    meter_seal_number: "Нөмірі",
    seal_place_name: "Орнату орны",
    date_meter_seal_set: "Орнату күні",
  },
  pointTrans: {
    trans: "Тоқ трансформаторлары",
    transformer_number: "Зауыттық нөмірі",
    transformer_name: "Түрі",
    koef: "Коэффициент",
    meter_seal_number: "Пломбаның нөмірі",
  },
  reportsInfo: {
    title: "Есептік нысандар",
    "application-2": {
      title: "Ағымдағы жылға арналған электрмен жабдықтау шартына №2 қосымша",
    },
    "application-1": {
      title: "Ағымдағы жылға арналған электрмен жабдықтау шартына №1 қосымша",
    },
    "form-470": {
      title: "Ф-470 Шығындарды есептеу қосымшасы",
    },
    download: "Сақтау",
    show: "Көрсету",
    "consumption-report": {
      title: "Электр энергиясының шығыны туралы мәліметтер",
    },
    "invoice-act": {
      title: "Орындалған жұмыстардың актісі",
    },
    "invoice-bill": {
      title: "Төлем шоты",
    },
    "reconciliation-report": {
      title: "Өзара есеп айырысуларды салыстыру актісі",
    },
    "reconciliation-report-netto": {
      title: "Акт сверки нетто-потребитель",
    },
    "contract-vie": {
      title: "Договор ВИЭ",
    },
    "exp-invoice": {
      title: "Расходная накладная",
    },
    initial_period_later_than_final: "Бастапқы кезең соңғы кезеңнен кешірек",
    "no-data": "Таңдалған кезеңде деректер жоқ",
    "runtime-error": "Есепті құрастыру кезінде қате кетті",
    power_consumption: "Электр тұтыну режим туралы хабарлама",
  },
  paymentsInfo: {
    title: "Есептеу мен төлем",
    serv_electricity: "Электр энергиясы, тг (ҚҚС-пен)",
    serv_fine: "Өсімақы, тг",
    serv_duty: "Мемлекеттік баж, тг",
    serv_reconnect: "ЭҚҚ, тг (ҚҚС-пен)",
    calcs: "Төлем, тг",
    headers: {
      period: "Кезең",
      sum_in: "Кіріс сальдосы, тг",
      sum_calc: "Есептелді, тг",
      sum_pay: "Төленді, тг",
      sum_out: "Шығыс сальдосы, тг",
    },
    "headers-electricity": {
      count_calc: "кВт∙сағ",
      sum_calc_no_nds: "Есептелді, тг (ҚҚС-сыз)",
      sum_nds: "ҚҚС, тг",
      avg_tariff: "Орт.тариф, тг/(кВт∙сағ.) (ҚҚС-сыз)",
    },
    "headers-reconnect": {
      sum_calc: "Есептелді, тг (ҚҚС-пен)",
    },
    "headers-calc": {
      date_pay: "Төлем күні",
      sum_pay: "Төлем сомасы, тг",
    },
  },
  "action-send-count": {
    actions: "Шарт бойынша іс-әрекеттер",
    send_count: "Көрсеткіштерді беру",
    info_on_date: "{data}ж. Ф-401 Электр энергиясының шығыны туралы мәліметтер",
    contract_number: "{data} жылғы {contract} шарт, {roes}",
    date_today: "Көрсеткіштерді ұсыну күні",
    date_counts: "Жаңа көрсеткіштердің күнін таңдаңыз",
    account_point_number: "Есепке алу нүктесі",
    meter_number: "Есепке алу құралы",
    indications_end: "Алдыңғы көрсеткіштер (жиынтық)",
    consumption_value_calc: "Электр энергиясының алдыңғы шығыны",
    indications_new: "Жаңа көрсеткіштер",
    indications: "Көрсеткіштер (фото)",
    send_counts: "Көрсеткіштерді жіберу",
    select_file: "Файлды таңдау",
    check_data: "Жаңа көрсеткіштердің күнін таңдаңыз",
    point_name: "Есепке алу нүктесінің атауы",
    point_adres: "Есепке алу нүктесінің мекенжайы",
    prec: "Мәнділігі",
    koef: "Коэффициент",
    calc_type: "Есептеу белгісі",
    less_than_previous: "Көрсеткіштер бұрынғы көрсеткіштерден аз",
    greater_than_subsequent: "Көрсеткіштер кейінгі көрсеткіштерден көп",
    try_again: "Көрсеткіштер қабылданбайды, қайталап көріңіз.",
    not_access:
      "Өзгерістер енгізуге рұқсат жоқ. Шарт бойынша шот-фактура сақталды!",
    sended:
      "Көрсеткіштер қабылданды және «АлматыЭнергоСбыт» ЖШС-не берілді. Төлем шотының дайындығы туралы ақпарат қосымша келіп түсетін болады",
    input_value: "Мәнді енгізіңіз",
    confirm_next_page:
      "Келесі параққа өткен кезде Сіз енгізген көрсеткіштер жоғалады. Келесі параққа өтуді орындау керек пе?",
    file_size_error: "Тіркелген файлдың көлемі 28 Mb-тан аспауы керек",
    file_ext_error: "Рұқсат етілген файл пішімдері: png, jpg, jpeg, gif, pdf",
    already_taken:
      "{date} ж. көрсеткіштер «АлматыЭнергоСбыт» ЖШС-да бұрын қабылданған",
    consumption_more_50_percent:
      "Орташа айлық тұтыну алдыңғыға қарағанда 50%-ға артық. Көрсеткіштер жіберілетін болады, енгізілген көрсеткіштердің дұрыстығын тексеріңіз!",
    consumption_less_50_percent:
      "Орташа айлық тұтыну алдыңғыға қарағанда 50%-ға кем. Көрсеткіштер жіберілетін болады, енгізілген көрсеткіштердің дұрыстығын тексеріңіз!",
    calc: "Тұтыну",
    seal_deleted:
      "Есепке алу құралының пломбасы алынған, көрсеткіштерді жіберу мүмкін емес",
    point_disconnected:
      "Есепке алу құралы өшірілген, көрсеткіштерді жіберу мүмкін емес",
    yes: "иә",
    no: "жоқ",
    allPointsIndicationsAreRequired:
      "Есеп айырысу үшін барлық есепке алу нүктелері бойынша көрсеткіштерді көрсету қажет",
    indicationNotSend:
      "Назар аударыңыз! Көрсеткіштерді беру 20.01.2025 жылдан бастап мүмкін болады.",
    message1:
      "Көрсеткіштер «АлматыЭнергоСбыт» ЖШС базасына енгізілді. Төлем шоты кейін жіберілетін болады. Шоттың дайындығы туралы хабарлама сіздің электрондық поштаңызға жолданады",
    message2:
      "Көрсеткіштер «АлматыЭнергоСбыт» ЖШС базасына енгізілді. Көрсеткіштерді қайта жіберу үшін {adres} мекенжайы бойынша орналасқан {roes}-ге жүгіну қажет.",
    firstDay: "Көрсеткіштерді айдын 1-күніне енгізуге тыйым салынған",
  },
  actions: {
    title: "Шарт бойынша іс-әрекеттер",
    send: "Көрсеткіштерді беру",
    is_mobile:
      "Құрметті тұтынушы!\n" +
      "Қызметтерді толық көлемде алу үшін NCLayer бағдарламасы орнатылған дербес компьютерді пайдалануды сұраймыз.\n" +
      "Бұл жөнге келтіру жұмыстарын жүргізу кезеңіндегі уақытша әдіс болып табылады.\n" +
      "Біз жұмыстардың аяқталғаны туралы әлеуметтік желілерде қосымша хабарлайтын боламыз.",
    "change-plan": {
      once: "Өтінімді айына бір рет қана жіберуге болады",
      "select-status": "Мәртебені таңдаңыз",
      title: "Сату жоспары",
      create: "Өтінім жасау",
      action: "Жоспарды өзгерту",
      number: "Нөмірі",
      date_create: "Жасау күні",
      date_send: "Жіберу күні",
      contract: "Шарттың нөмірі",
      status: "Мәртебесі",
      month: "Ай",
      kvt: "кВт.сағат ()",
      kvtnew: "кВт.сағат ()",
      request:
        "№ {contract_number} Шарт бойынша электр энергиясын жеткізу туралы өтінім",
      fill:
        "{period_begin} - {period_end} кезеңдегі электр энергиясын жеткізу туралы деректерді толтырыңыз",
      cancel: "Болдырмау",
      save_draft: "Шимайжазбаны сақтау",
      send: "Жіберу",
    },
    akt: {
      title: "Өзара есеп айырысуларды салыстыру актісі",
      "group-header":
        '<span style="color:black;">{period_begin}</span> жылдан <span style="color:black;">{period_end}</span> жылға дейінгі кезеңдегі акт,  <span style="color:black;">{action_date}</span> берілді',
      "act-sum": "Акт бойынша сома",
      "reject-reason": "Себебі бойынша қабылданбады",
      "select-reject-reason": "Себебін таңдаңыз",
      "need-reject-reason":
        "Әрекетті одан әрі орындау үшін қабылдамаудың себебін көрсетіңіз",
    },
    akt_work: {
      title: "Орындалған жұмыстардың актісі",
      "group-header":
        '<span style="color:black;">{action_date}</span> жылғы <span style="color:black;">{period}</span> акт <span style="color:black;">{act_number}</span>',
    },
    akt_netto: {
      title: "Акт сверки нетто-потребитель",
      "group-header":
        'Акт за период с <span style="color:black;">{period_begin}</span> по <span style="color:black;">{period_end}</span>, выдан <span style="color:black;">{action_date}</span>',
      "act-sum": "Сумма по акту",
      "reject-reason": "Отклонен по причине",
      "select-reject-reason": "Укажите причину",
      "need-reject-reason":
        "Укажите причину отклонения для дальнейшего выполнения действия",
    },
    contract_vie: {
      title: "Договор ВИЭ",
      "group-header":
        'Договор <span style="color:black;">{contract_number}</span>, от <span style="color:black;">{contract_date}</span>',
      "reject-reason": "Отклонен по причине",
      "select-reject-reason": "Укажите причину",
      "need-reject-reason":
        "Укажите причину отклонения для дальнейшего выполнения действия",
    },
    exp_invoice: {
      title: "Расходная накладная",
      "group-header":
        'Накладная за период с <span style="color:black;">{period_begin}</span> по <span style="color:black;">{period_end}</span>, выдана <span style="color:black;">{action_date}</span>',
      "act-sum": "Сумма по накладной",
      "reject-reason": "Отклонен по причине",
      "select-reject-reason": "Укажите причину",
      "need-reject-reason":
        "Укажите причину отклонения для дальнейшего выполнения действия",
    },
    accept: {
      title: "Электрмен жабдықтау шартының акцепті туралы өтініш",
      "required-fields":
        "Электрмен жабдықтау шартының акцепті туралы өтініш беру үшін келесі жолдарды толтыру қажет",
      "invalid-phone": "Телефон нөмірі қате",
      "phone-number": "Ұялы нөмір",
      "phone-number-media": "Мультимедиялық хабарға арналған ұялы нөмір",
      "phone-number-messenger": "Мессенджерлерге арналған ұялы нөмір",
      "mail-address": "	Пошталық мекенжайы",
      "before-route-leave":
        "Құрметті пайдаланушы, шарт бойынша кез келген іс-әрекеттер «Электрмен жабдықтау шартының акцепті туралы өтініш» нысанына қол қойылмай орындалмайды, жапқыңыз келіп тұрғанына сенімдісіз бе?",
      email: {
        "card-no-email":
          "Электрондық мекен-жай енгізілмеген. Акцептке қол қою үшін бейінге өтіп, Сіздің электрондық мекен-жайыңызды енгізіп, растаңыз.",
        "card-not-verified":
          "Сіздің электрондық мекен-жайыңыз{email} расталған жоқ. <br />Акцептке қол қою үшін бейінге өтіп, электрондық мекен-жайды растау қажет.",
        "open-profile-page": "Бейінге өту",
      },
    },
    statuses: {
      all: "Барлығы",
      pending: "Күтілуде",
      signed: "Қол қойылды",
      rejected: "Қабылданбады",
    },
    "choose-reject-reason":
      "Әрекетті одан әрі орындау үшін қабылдамаудың себебін көрсетіңіз",
  },
  debtNotifications: {
    title: "Қарыз туралы хабарламалар",
    title_single: "Қарыз туралы хабарлама",
    notice_seen: "Таныстым",
    saldo: "Ағымдағы сальдо",
    dateFilter: "Күні бойынша:",
    filterNew: "алдымен жаңасы",
    filterOld: "алдымен бұрынғылар",
    number_date: "Хабарламаның нөмірі және күні",
    debt_sum: "Қарыз сомасы, тг",
    date_formed: "Хабарламаны қалыптастыру күні",
    date_send: "Хабарлама жіберілген күн",
    delivery_type: "Жеткізу түрі",
    months: "Қарыз мерзімі, ай",
    repaid: "Өтелді",
    date_last: "Соңғы төлем күні",
    pay_last: "Хабарламалар бойынша төленді, тг",
    rowTooltip: "Толығырақ",
  },
  invoices: {
    docs: "Сіз құжаттарды «ЭШФ» АЖ порталынан ала аласыз",
    invoice_label: "ШФ",
    invoice_date_preposition: "ж.",
    invoice_additional: "қосымша",
    invoice_revised: "түзетілген",
    to_invoice: "ШФ-ға",
    to_invoice_preposition: "за",
    headers: {
      name: "Тауардың (жұмыстардың, қызметтердің) атауы",
      code: "Тауар коды (ЕАЭО СЭҚ ТН)",
      unit: "Өлшем бірлігі",
      quantity: "Саны (көлемі)",
      price: "Бағасы",
      cost: "Тауарлардың (жұмыстардың, қызметтердің) құны",
      tax_rate: "ҚҚС мөлшерлемесі",
      tax_sum: "ҚҚС сомасы",
      cost_with_tax: "Сату құнының барлығы",
      total_taxable: "Салық салынатын айналым жиыны",
      total_nontaxable: "Салық салынбайтын айналым жиыны",
      total: "Шот бойынша барлығы",
    },
  },
  $vuetify: {
    datePicker: {
      itemsSelected: "{0} таңдалған",
      nextMonthAriaLabel: "Келесі ай",
      nextYearAriaLabel: "Келесі жыл",
      prevMonthAriaLabel: "Алдыңғы ай",
      prevYearAriaLabel: "Алдыңғы жыл",
    },
    dataIterator: {
      rowsPerPageText: "Парақтағы жолдар:",
      rowsPerPageAll: "Барлығы",
      pageText: "{2}-ң {0}-{1}",
      noResultsText: "Тиісті жолдар табылмады",
      nextPage: "Келесі бет",
      prevPage: "Алдыңғы бет",
      loadingText: "Жүктеу",
    },
    dataFooter: {
      rowsPerPageText: "Парақтағы жолдар:",
      itemsPerPageAll: "Барлығы",
      pageText: "{2}-ң {0}-{1}",
      noResultsText: "Тиісті жолдар табылмады",
      nextPage: "Келесі бет",
      prevPage: "Алдыңғы бет",
      loadingText: "Жүктеу",
    },
    dataTable: {
      itemsPerPageText: "Парақтағы жолдар:",
      sortBy: "Cұрыптау",
      ariaLabel: {
        activateAscending: "KZ Активирована сортировка",
        sortNone: "KZ Без сортировки",
        activateNone: "KZ Сортировка не активна",
      },
    },
    noDataText: "Көрсету үшін деректер жоқ",
    carousel: {
      prev: "Предыдущий визуальный",
      next: "Следующий визуальный",
    },
  },
  appeals: {
    title: "Менің өтініштерім",
    create: "Өтінішті құру",
    edit: "өзгерту",
    select_status: "Мәртебені таңдаңыз",
    number: "Нөмірі",
    date_create: "Жасау күні",
    theme: "Тақырыбы",
    contract_number: "Шарттың нөмірі",
    status: "Мәртебесі",
    contact_human: "Байланысушы тұлға",
    email: "Email",
    phone: "Байланыс нөмірі",
    theme_appeal: "Өтініштің тақырыбы",
    contract: "Шарт",
    message: "Хабарлама мәтіні",
    save_draft: "Шимайжазбаны сақтау",
    cancel2: "Бас тарту",
    cancel: "Өтінімді болдырмау",
    send: "Жіберу",
    fio: "Тегі Аты Әкесінің аты",
    select_theme: "Өтініштің тақырыбын таңдаңыз",
    all: "Барлығы",
    input_text: "Өтініштің мәтінін енгізіңіз",
    drag_file:
      "50 Мб-тан аспайтын кез келген пішімдегі файлды тіркеу үшін оны көшіріңіз немесе ",
    browse: "Шолу",
    answer: "Ответ по обращению",
    title2: "Шығыс өтініштер",
    in: {
      title: "Кіріс өтініштер",
      title2: "Кіріс өтініштер",
      date_send: "Келіп түскен күні",
      drag_file:
        "28 Мб-тан аспайтын кез келген пішімдегі файлды тіркеу үшін оны көшіріңіз немесе ",
      send: "АЭЖБ-ге жіберу",
      close: "Жабу",
      close_confirm: "Деректер сақталмайды, шыққыңыз келетініне сенімдісіз бе?",
      date_create: "Келіп түскен күні",
    },
  },
  rating: {
    mark: "Қосымшаның жұмысын бағалаңыз",
    imp: "Сіздің пікіріңіз біз үшін маңызды",
    cancel: "Болдырмау",
    make_mark: "Бағалау",
    thanks: "Бағалағаңыз үшін рахмет!",
    close: "Жабу",
    stars5: "Өте жақсы",
    stars4: "Жақсы",
    stars3: "Жақсартуға болатын нәрселер бар",
    stars2: "Орташа",
    stars1: "Нашар",
    comment: "Түсініктеме қосу",
    bad_interface: " Ыңғайсыз интерфейс",
    few_func: " ЖК-нің функциялары жеткіліксіз",
    other: "Басқасы",
  },
  "pay-form": {
    pay: "Төлеу",
    close: "Жабу",
    "cur-period": "Ағымдағы кезең үшін",
    "sum-pay": "Төленетін сома",
    "payed-summ": "Төленетін сома",
    "input-summ": "Төленетін соманы енгізіңіз",
    "invoice-bill": "Төлем шоты",
    "have-no-bill": "Төленбеген шоттар жоқ",
    "choose-acquirer": "Төлем әдісін таңдаңыз",
    "sum-range-error":
      "Сома 60 теңгеден кем емес және 499 999 теңгеден артық болмауы тиіс",
    "for-period": "Кезең үшін",
  },
  electricityReport: {
    name: "Ф-402 Электр тўтыну тізімдемесі ",
    show: "Көрсету",
    label: "Кезеңді таңдаңыз",
    contractAmount: "Есептік кезенде барлығы",
    tableHeaders: {
      pointNumber: "ЕН коды",
      pointName: "ЕН атауы",
      meterNumber: "Есептегіштің нөмірі/Тарифтік аймақ",
      indicationsBegin: "Қезең басындағы көрсеткіштер",
      indicationsEnd: "Қезең соңындағы көрсеткіштер",
      indicationsDiff: "Көрсеткіштердің айырмасы",
      transformCoef: "Есеп. Коэф.",
      consumptionMeter: "ЕҚ бойынша шығын, кВт.с",
      consumptionCalc: "ЕҚ-сыз бойынша шығын, кВт.с",
      consumptionDop: "Қосымша шығын, кВт.с",
      consumptionSPM: "ЖҚҚ, кВт.с",
      consumptionLost: "шығындар, кВт.с",
      consumptionSub: "Қосалқы абоненттер, кВт.с",
      consumptionRecalc: "Қайта есептеу, кВт.с",
      consumptionOperation: "Тұтыну, кВт.с",
    },
  },
  "pay-instruct": {
    str1: "Заңды тұлғалардың жеке кабинетіндегі онлайн төлем",
    str2:
      "Жеке кабинетте «Алатау Жарық Компаниясы» АҚ филиалы - «Энергосбыт» заңды тұлғалары үшін онлайн режимде «Электр энергиясы» қызметіне төлем жасау мүмкіндігі қарастырылған.  Бір тұтынушы бірнеше рет төлем жасай алады.",
    str3: "Төлем жасау функциясы Жеке кабинеттің жоғарғы панелінде қолжетімді:",
    str4:
      "Егер ағымдағы сәтте қалыптасқан шот болмаса, онда «Төлеу» белгішесін басқан кезде Жүйе «Төленбеген шоттар жоқ» деген хабарламаны көрсетеді:",
    str5:
      "«Төлеу» батырмасын басқан кезде, Qiwi және Kaspi арқылы төлем жасау әдісін таңдау мүмкіндігі бар терезе ашылады:",
    str6:
      "Әрі қарай Сіз төлем әдісін таңдап, соманы толтырып, «Төлеу» батырмасын басуыңыз қажет:",
    str7:
      "Егер Сіз Qiwi төлем әдісін таңдасаңыз, онда жүйе сізді «Qiwi интернет-банкингі» сервисіне ауыстырады:",
    str8:
      "Егер Сіз Kaspi төлем әдісін таңдасаңыз, онда жүйе сізді «Kaspi интернет-банкингі» сервисіне ауыстырады:",
    str9:
      "Банк тарапынан төлем қабылданады және Жүйеде төлемнің сәтті жүргізілуі туралы хабарлама көрсетіледі. Төлем келіп түскен және деректер базасында тіркелген күн төлем күні болып есептеледі.",
  },
  "sign-act-instruct": {
    str2:
      "Тұтынушының Өзара есеп айырысуларды салыстыру актілеріне және Орындалған жұмыстар актілеріне қол қоюы, оларды қабалдамауы Жеке кабинетте Аудандық энергия сату бөлімшесіне (РОЭС) жүгінбей-ақ қолжетімді.",
    str3: "1.	Актіге қол қою",
    str4:
      "«ЭЦҚ-мен қол қою» әрекеті ЭЦҚ-мен қол қойылып орындалады және акт қабылданбаған емес (яғни, «Қабылданбаған» мәртебесінде емес және қабылдамауға себебі жоқ) немесе бұрын Жеке кабинет пайдаланушысы оған қол қоймаған (яғни, «Қол қойылған» мәртебесінде емес) жағдайда ғана пайдаланушыға қолжетімді болады.",
    str5:
      "1.	Актіге қол қою үшін «Шарт бойынша іс-әрекеттер» нысанын ашу керек (1-сурет).",
    str6: "1-сурет  – «Шарт бойынша іс-әрекеттер» нысаны",
    str7:
      "2.	Әрі қарай, қалыптастырылған актілер тізімінен қажетті кезең үшін «Өзара есеп айырысуларды салыстыру актісін» немесе «Орындалған жұмыстар актісін» (2-сурет) таңдау керек.",
    str8:
      "2-сурет  – «Өзара есеп айырысуларды салыстыру актісі» ашылған кезіндегі нысан",
    str9: "3.	ЭЦҚ арқылы қалыптастырылған актіге қол қою (3 және 4-сурет).",
    str10:
      "3-сурет  –  «Күтуде» мәртебесімен «Өзара есеп айырысуларды салыстыру актісі»  ",
    str1: "4-сурет  – ЭЦҚ таңдау терезесі",
    str11:
      "4.	Актіге қол қойылғаннан кейін «Алатау Жарық Компаниясы» АҚ филиалы - «Энергосбыт»-тың тарапынан Жеке кабинет профилінде көрсетілген электрондық мекенжайға актіге қол қою туралы хабарлама келіп түседі.",
    str12:
      "5.	«Шарт бойынша іс-әрекеттер»  нысанындағы актінің мәртебесі «Қол қойылған» болып өзгереді (5-сурет). ",
    str13:
      "5-сурет  – Өзара есеп айырысуларды салыстыру актісінің «Қол қойылған» мәртебесі",
    str14:
      "6.	Қол қоюдың QR кодтары бар қол қойылған акт «Шарт бойынша іс-әрекеттер» нысанында көрсетіледі.",
    str15: "2.	Актілерді қабылдамау",
    str16:
      "Егер актіні қабылдамау талап етілсе, онда бұл әрекет ЭЦҚ қол қойылмай орындалады және «Шарт бойынша іс-әрекеттер» нысанында қолжетімді болады.",
    str17:
      "1.	«Өзара есеп айырысуларды салыстыру актісін» немесе «Орындалған жұмыстар актісін» ашып, қабылдамағанды таңдап, «Қабылдамау» әрекетін басу керек (6-сурет).",
    str18: "6-сурет  – «Қабылдамау» әрекетінің орналасқан орны",
    str19:
      "2.	«Қабылдамау» әрекетін басқаннан кейін ашылмалы тізімнен қабылдамау себебін таңдауға болатын терезе ашылады (7 және 8-сурет).",
    str20: "7-сурет  –Қабылдамау себебін таңдау терезесі",
    str21: "8-сурет  - Қабылдамау себептерінің тізімі",
    str22:
      "3.	Себеп көрсетілгеннен кейін акт мәртебесі «Қабылданбаған» болып өзгереді. (9-сурет ).",
    str23: "9-сурет  – Қабылданбағаннан кейінгі акт мәртебесі ",
  },
  budget_cons_not: {
    str1: "ХАБАРЛАМА",
    str2: "Құрметті тұтынушы!",
    str3:
      "09.07.2004 жылғы №588-II  «Электр энергетикасы» туралы ҚР Заңының 19-бабының 2-бабының 2-тармақшасына сәйкес электр және жылу энергиясын тұтынушылар электр және жылу энергиясын сатып алу-сату шартында айқындалған энергия тұтыну режимдерiн сақтауға міндетті.",
    str4:
      "ҚР Энергетика министрінің 23.10.2017 жылғы №356 бұйрығымен бекітілген Мемлекеттік бюджеттен қаржыландырылатын заңды тұлғаларға арналған электрмен жабдықтаудың үлгілік шартының (бұдан әрі – Үлгілік шарт) 7-тарм. сәйкес Тұтынушы кезекті жылға электр энергиясын тұтыну көлемін анықтау үшін жабдықтау жылының алдыңғы жылы басталғанға дейін 30 күннен кешіктірмей осы Шартқа 2-қосымшаға сәйкес нысан бойынша электр энергиясын беру туралы алдын ала өтінім береді. Көрсетілген құжат жеткізудің тиісті жылына арналған электр тұтыну режимін анықтайды.",
    str5:
      "Үлгілік шарттың 15-тарм. 2-тармақшасына сәйкес Тұтынушы электр энергиясын сатып алу-сату шартында айқындалған энергия тұтыну режимдерiн сақтауға міндетті.",
    str6:
      "Үлгілік шарттың 16-тарм. сәйкес Сатушы энергия беруші ұйымды қатыстыру арқылы Тұтынушы хабарламаны алған күннен бастап 5 (бес) жұмыс күнінен кем емес Тұтынушыға хабарлама жіберу фактісін растауға мүмкіндік беретін шарт акцептінде (электрондық поштамен, факспен, пошта жөнелтілімімен, қысқа мәтіндік хабарламамен, мультимедиялық хабарламамен, қолданыстағы мессенджерлерді пайдалану) көрсетілген тәсілдермен Тұтынушыны ескерте отырып, Шартта белгіленген электр тұтыну режимі бұзылған жағдайларда электр энергиясын беруді толық немесе ішінара тоқтатуға құқылы.",
    str7:
      "Баяндалғанға байланысты, Сіздің энергия тұтыну режиміңізді {current_year} жылға арналған электр энергиясын беру туралы алдын ала берген өтініміңізге сәйкес келтіруіңіз қажет, олай болмаған жағдайда, ағымдағы есептік кезеңнің қорытындылары бойынша «АлматыЭнергоСбыт» ЖШС есептік кезең аяқталған сәттен бастап 5 (бес) жұмыс күні өткеннен кейін Сізге электр энергиясын беруді толық немесе ішінара тоқтатуға мәжбүр болады.",
    str8:
      "Электрмен жабдықтау объектілерін қайта қосқаны үшін міндетті түрде қайта қосуға 17 321.00 теңге мөлшерінде төлем алынады.",
  },
  other_cons_not: {
    str1:
      "09.07.2004 жылғы №588-II  «Электр энергетикасы» туралы ҚР Заңының 19-бабының 2-бабының 2-тармақшасына сәйкес электр және жылу энергиясын тұтынушылар электр және жылу энергиясын сатып алу-сату шартында айқындалған энергия тұтыну режимдерiн сақтауға міндетті.",
    str2:
      "ҚР Энергетика министрінің 23.10.2017 жылғы №356 бұйрығымен бекітілген Электр энергиясын тұрмыстық емес мұқтаждар үшін пайдаланатын тұтынушыларға арналған электрмен жабдықтаудың үлгілік шартының (бұдан әрі – Үлгілік шарт) 8-тарм. сәйкес Тұтынушы кезекті жылға электр энергиясын тұтыну шамасын анықтау үшін жеткізу жылының алдыңғы жылы басталғанға дейін күнтізбелік 30 (отыз) күннен кешіктірмей осы Шартқа 2-қосымшаға сәйкес нысан бойынша электр энергиясын беру туралы алдын ала өтінім береді. Көрсетілген құжат жеткізудің тиісті жылына арналған электр тұтыну режимін анықтайды.",
    str3:
      "Үлгілік шарттың 12-тарм. 2-тармақшасына сәйкес Тұтынушы электр энергиясын сатып алу-сату шартында айқындалған энергия тұтыну режимдерiн сақтауға міндетті.",
    str4:
      "Үлгілік шарттың 13-тарм. сәйкес Сатушы энергия беруші ұйымды қатыстыру арқылы Тұтынушы хабарламаны алған күннен бастап 5 (бес) жұмыс күнінен кем емес Тұтынушыға хабарлама жіберу фактісін растауға мүмкіндік беретін шарт акцептінде (электрондық поштамен, факспен, пошта жөнелтілімімен, қысқа мәтіндік хабарламамен, мультимедиялық хабарламамен, қолданыстағы мессенджерлерді пайдалану) көрсетілген тәсілдермен Тұтынушыны ескерте отырып, шартта белгіленген электр тұтыну режимі бұзылған жағдайларда электр энергиясын беруді толық немесе ішінара тоқтатуға құқылы.",
    str5:
      "Баяндалғанға байланысты, Сіздің энергия тұтыну режиміңізді {current_year} жылға арналған электр энергиясын беру туралы алдын ала берген өтініміңізге сәйкес келтіруіңіз қажет, олай болмаған жағдайда, ағымдағы есептік кезеңнің қорытындылары бойынша «АлматыЭнергоСбыт» ЖШС есептік кезең аяқталған сәттен бастап 5 (бес) жұмыс күні өткеннен кейін Сізге электр энергиясын беруді толық немесе ішінара тоқтатуға мәжбүр болады.",
    str6:
      "Үлгілік шарттың 9-тарм. айқындалған тәртіппен және мерзімде, ағымдағы айдың 26 (жиырма алтыншы) күніне дейін «АлматыЭнергоСбыт» ЖШС-не Үлгілік шартқа 2-қосымшаға сәйкес нысан бойынша электр энергиясын беру туралы алдын ала өтінім бере отырып, Сіз шартпен анықталған электр тұтыну режимін келесі  есептік кезеңге түзете аласыз.",
    str7:
      "Электрмен жабдықтау объектілерін қайта қосқаны үшін міндетті түрде қайта қосуға 17 321.00 теңге мөлшерінде төлем алынады.",
  },
};
